import { apiGet } from './Api_Functions'

let status = 'OFF'
let intervalId = null

const fetchCellGeneralStatus = async () => {
  try {
    const response = await apiGet('cellGeneralStatus')
    status = response
  } catch (error) {
    console.error('Error fetching cell status')
    status = 'OFF'
  }
}

export const startCellStatusPolling = () => {
  if (intervalId) return
  fetchCellGeneralStatus() // initial fetch
  intervalId = setInterval(fetchCellGeneralStatus, 1000) // fetch every 1000 ms
}

export const stopCellStatusPolling = () => {
  clearInterval(intervalId)
  intervalId = null
  status = 'OFF'
}

const getCellGeneralStatus = () => status

const isCellRunning = () => status === 'AUTOMATIC'

export { getCellGeneralStatus, isCellRunning }
